"use client";

import { ShieldCheck, Users, FileText, Heart, ClipboardCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Excellence() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: itemsRef,
    isVisible: itemsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const credentials = [{
    icon: ShieldCheck,
    label: "DDS QUALIFIED",
    description: "Fully vetted and certified by the Connecticut Department of Developmental Services."
  }, {
    icon: Users,
    label: "PERSON-CENTERED",
    description: "Individualized support plans tailored to unique personal goals and needs."
  }, {
    icon: FileText,
    label: "COMPLIANCE READY",
    description: "Rigorous documentation and administrative standards for peace of mind."
  }, {
    icon: Heart,
    label: "COMMUNITY FOCUSED",
    description: "Dedicated to fostering independence and meaningful social integration."
  }, {
    icon: ClipboardCheck,
    label: "QUALITY ASSURED",
    description: "Continuous monitoring and improvement of our care delivery systems."
  }];
  return <section data-section-id="4418" id="state-qualified-excellence" className="relative overflow-hidden bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 md:h-96 md:w-96 opacity-25 blur-2xl" style={{
      backgroundColor: "var(--chart-1)"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className="text-center">
          <h2 className={`font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-foreground font-default mb-3 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            our mission statement and our promise to you
          </h2>
          <p className={`text-center font-default text-foreground/70 max-w-2xl mx-auto py-6 text-base md:text-lg leading-relaxed transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Empowering individuals through compassionate, qualified support services tailored to the unique needs of our Connecticut community.
          </p>
        </div>

        <div ref={itemsRef} className="relative mt-12 md:mt-16">
          <div aria-hidden="true" className="hidden md:block absolute left-0 right-0 top-[60px] h-px" style={{
          backgroundColor: "var(--border)",
          opacity: 0.4
        }} />

          <div aria-hidden="true" className="md:hidden absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2" style={{
          backgroundColor: "var(--border)",
          opacity: 0.3
        }} />

          <div className="relative grid grid-cols-2 md:grid-cols-5 gap-y-12 gap-x-6 md:gap-x-4">
            {credentials.map((item, i) => {
            const Icon = item.icon;
            return <div data-index={i} key={item.label} className={`relative flex flex-col items-center text-center px-2 transition-all duration-700 ease-out ${itemsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDelay: `${i * 120}ms`
            }}>
                  {i < credentials.length - 1 && <div aria-hidden="true" className="hidden md:block absolute right-0 top-8 bottom-8 w-px translate-x-2" style={{
                backgroundColor: "var(--border)",
                opacity: 0.6
              }} />}

                  <div className="relative flex items-center justify-center w-20 h-20 md:w-[120px] md:h-[120px] rounded-lg bg-card border border-border">
                    <Icon strokeWidth={1.5} className="w-10 h-10 md:w-12 md:h-12" style={{
                  color: "var(--chart-1)"
                }} aria-hidden="true" />
                  </div>

                  <h3 className="mt-5 font-mono text-[11px] md:text-xs tracking-[0.2em] uppercase text-foreground font-default">
                    {item.label}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed max-w-[180px] font-default" style={{
                color: "var(--muted-foreground)"
              }}>
                    {item.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}